<template>
    <div class="zsxx_h5">
      <TopTabs :list="this.$nav8"/>
      <div class="content" v-html="obj.content"></div>
    </div>
</template>

<script>
import TopTabs from '@/components/topTabs_h5/index'

export default {
  name: 'Dtxx',
  components: { TopTabs },
  props: {
    obj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {

    }
  },
  computed: {},
  watch: {},
  created () {

  },
  mounted () {},
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .zsxx_h5 {
    width: 100%;
  }
</style>
